import { Component, ElementRef, OnInit,ViewChild, HostListener } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import SignaturePad from "signature_pad";


@Component({
  selector: 'app-signature-input-dialog',
  templateUrl: './signature-input-dialog.component.html',
  styleUrls: ['./signature-input-dialog.component.scss']
})
export class SignatureInputDialogComponent  extends DialogContentBase implements OnInit {


  constructor(
    public dialog: DialogRef, 
    public uiNotification: UiNotificationService,
  ) {
    super(dialog);
  }

  @ViewChild("canvas", { static: true }) canvas: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    //this.dialog.close({ text: 'Cancel' });
}

  signpad: SignaturePad;
  signImage:any;

  signatureValue = "";

startSignPadDrawing(event: Event) {
}


movedFinger(event: Event) {
}


clearSignPad() {
  this.signpad.clear();
}


  clear() {
    this.signpad.clear();
  }

  ngOnInit(): void {
    this.signpad = new SignaturePad(this.canvas.nativeElement);
  }

  confirm(){
    const base64ImageData = this.signpad.toDataURL();
    this.signImage = base64ImageData;
    this.dialog.close({ text: 'OK' , signature: base64ImageData});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

}
